import { defaultTheme } from '@sleepstation/themes-public-site'
import { createTheme } from '@sleepstation/utils'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const infoCardThemeBlue = createTheme(
  `InfoCardBlue`,
  defaultTheme.api,
  {
    colors: {
      backgroundPrimary: `blueDark`,
      backgroundPrimaryStart: `blueDark`,
      backgroundPrimaryEnd: `blueDark`,
      title: `white`,
      bodyBackground: `bluePale`,
      highlight: `blueDark`,
    },
  },
  defaultTheme
)

export default infoCardThemeBlue
